/** Размер картинки QR кода */
export const QRCODE_IMAGE_WIDTH = 200;
